
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Table } from "@common/src/utils/decorator";
import { namespace } from "vuex-class";
import { InjectFunction } from "@common/src/utils/decorator";
import CouponContent from "../../components/coupon-discount-content.vue";
import t from "@common/src/i18n/t";
const coupon = namespace("coupon");

@InjectFunction("dayjs", "permitApp", "addCurrencyUnit", "emptyToLine", "appCode")
@Component({
  components: { CouponContent }
})
@Table("loadListData", { pageSize: 20 })
export default class ComCouponSelector extends Vue {
  @coupon.Action queryList;
  @Prop({ default: false, type: Boolean })
  visible: boolean;
  @Prop({ default: () => [], type: Array })
  storeTypeArr: any;
  @Prop({ default: () => [], type: Array })
  times: any;
  get couponSearchList() {
    return [
      {
        label: t("marketing.discount-coupon-name"),
        type: "input",
        value: "",
        prop: "activityName"
      }
    ];
  }
  handleSelectedCoupon() {
    this.$emit("selectDone", this.selectedRow);
    this.selectedRow = [];
  }
  searchForm: any = {
    activityName: ""
  };
  created() {
    // this.loadListData();
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        this.searchForm[item.prop] = item.value;
      }
    });
    this.loadListData();
  }
  couponList: any = [];
  @Table.LoadDataMethod()
  loadListData() {
    return this.queryList({
      ...this.searchForm,
      activityStatus: "01,04", // 进行中状态
      pageNum: 1,
      pageSize: 999,
      // activityEffectiveFrom: this.times?.[0].substring(0, 8) || "",
      activityEffectiveTo: this.times?.[1].substring(0, 8) || "",
      ...(this.appCode === "speedbiz-operation" ? { storeTypes: this.storeTypeArr } : {})
    }).then(data => {
      this.couponList = data.data.list;
      return data;
    });
  }
  selectedRow: any = [];
  handleRowSelect(rows) {
    this.selectedRow = rows || [];
  }
  checkable(row) {
    return !Object.keys(this.selectedRow).length || this.selectedRow.cardTemplateCode === row.cardTemplateCode;
  }
  handleCloseSelector() {
    this.$emit("update:visible", false);
  }
  handleCancel() {
    this.$emit("update:visible", false);
  }
  @Watch("visible")
  handleVisibleChange(val) {
    if (val) {
      if (this.searchForm.activityName) {
        this.$refs["searchBar"] && (this.$refs["searchBar"] as any).reset();
      } else {
        this.loadListData();
      }
    }
  }
}
